<form class="cost-center-form" [formGroup]="unitForm" (ngSubmit)="cleanForm(unitForm) && unitForm.valid && formSubmit(unitForm)">
    <div class="responsive-columns row">
        <div class="form-group col-sm-7">
            <label for="name">Nome*</label>
            <input id="name" class="form-control" [class.invalid]="checkErrorField('name')"
                formControlName="name">
            <small class="form-text text-danger">
                Campo obrigatório
            </small>
        </div>
        <div class="form-group col-sm-7">
            <label for="cnpj">CNPJ*</label>
            <input id="cnpj" class="form-control" [textMask]="{mask: cnpjMask}"
                [class.invalid]="checkErrorField('cnpj')"
                formControlName="cnpj">
            <small class="form-text text-danger">
                Cnpj inválido
            </small>
        </div>
    </div>
    <div class="responsive-columns row">
        <div class="form-group col-sm-7">
            <label for="code">Código*</label>
            <input id="code" class="form-control" [class.invalid]="checkErrorField('code')"
                formControlName="code">
            <small class="form-text text-danger">
                Campo obrigatório
            </small>
        </div>
        <div class="form-group col-sm-7">
            <label for="type">Tipo de Endereço*</label>
            <select class="form-control" [class.invalid]="checkErrorField('addressTypesId')" formControlName="addressTypesId">
                <option [value]="item.id" *ngFor="let item of addressTypes">
                    {{item.name}}
                </option>
            </select>
            <small class="form-text text-danger">
                Campo obrigatório
            </small>
        </div>
    </div>
    <div class="submit-btn">
        <button type="submit" class="btn-orange" [disabled]="!unitForm.valid || loading">Salvar</button>
    </div>
</form>
